module.exports = __webpack_public_path__ + "static/media/clickup.2a5aa13b.svg";